import { observer } from 'mobx-react-lite'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { type NotesDialogViewModel } from './NotesDialogViewModel'
import { NotesDialog } from '@/features/jobs/details/components/CapturedInformationCard/NotesDialog'

export interface NotesDialogContainerProps {
  vm: NotesDialogViewModel
}

export const NotesDialogContainer = observer(function NotesDialogContainer({
  vm,
}: NotesDialogContainerProps) {
  return (
    <NotesDialog
      showing={vm.modal.showing}
      onRequestClose={vm.submit.pending ? undefined : vm.modal.close}
      onSubmit={vm.submit}
      isSubmitPending={vm.submit.pending}
    >
      <TextAreaContainer
        rows={8}
        model={vm}
        field="text"
        name="text"
        placeholder="Add some instructions or notes here"
        minLength={vm.fieldLengths.text.min}
        maxLength={vm.fieldLengths.text.max}
        error={vm.validation.getError('text')}
        status={vm.validation.getError('text') ? 'danger' : 'default'}
        data-test="provide-notes-text"
      />
    </NotesDialog>
  )
})
